import { Menu, X } from "lucide-react";
import { useState } from "react";
import "./header.css";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-container-tracking">
        {/* Logo */}
        <a href="https://www.fabelle.in/" className="navbar-logo">
          <img
            src="https://www.fabelle.in/images/logo.svg"
            alt="Fabelle Logo"
          />
        </a>

        {/* Desktop Links */}
        <div className="navbar-links">
          <a  className="nav-link">Home</a>
          <a className="nav-link">Shop</a>
          <a
            href="https://www.fabelle.in/sign-in"
            className="nav-link"
            onClick={() => setIsOpen(false)}
          >
            Login
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button className="menu-btn" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? (
            <X className="menu-icon" />
          ) : (
            <Menu className="menu-icon" />
          )}
        </button>
      </div>

      {isOpen && (
        <div className="mobile-menu">
          <a className="mobile-link" onClick={() => setIsOpen(false)}>
            Home
          </a>
          <a className="mobile-link" onClick={() => setIsOpen(false)}>
            Shop
          </a>
          <a
            href="https://www.fabelle.in/sign-in"
            className="mobile-link"
            onClick={() => setIsOpen(false)}
          >
            Login
          </a>
        </div>
      )}
    </nav>
  );
};

export default Header;
